var map = {
	"./Article_10/cover.jpg": "RT2F",
	"./Article_11/cover.jpg": "oMLZ",
	"./Article_12/cover.jpg": "+5BN",
	"./Article_13/cover.jpg": "muTN",
	"./Article_2/cover.jpg": "xxgI",
	"./Article_3/cover.jpg": "tBYw",
	"./Article_4/cover.jpg": "dFRf",
	"./Article_5/cover.jpg": "9hsP",
	"./Article_6/cover.jpg": "8wNK",
	"./Article_7/cover.jpg": "hc3w",
	"./Article_8/cover.jpg": "tB5V",
	"./Article_9/cover.jpg": "iN/y"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "hDCv";


//////////////////
// WEBPACK FOOTER
// ./src/assets/1st/Articles ^\.\/Article_.*\/cover\.jpg$
// module id = hDCv
// module chunks = 0